import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplexityEstimationResult } from '../../shared/complexity-mgnt/complexity-estimation-result';
import { ComplexityMngtService } from '../../shared/complexity-mgnt/complexity-mngt.service';
import { AggregationSevice } from '../../shared/preaggregation/aggregation-service';
import { ComplexityColumn } from '../../shared/complexity-mgnt/complexity-column';
import { ProjectService } from 'src/app/shared/project/project.service';
import { MatDialog } from '@angular/material/dialog';
import { TopValsModalComponent } from './top-vals-modal.component';
import { MaxMultStorageService } from './max-mult-storage.service';

@Component({
  selector: 'app-complexity-mgnt',
  templateUrl: './complexity-mgnt.component.html',
  styleUrls: ['../general.scss']
})
export class ComplexityMgntComponent implements OnInit {
    public loading: boolean = true;
    public projectId: string | undefined;

    public multiplier: number = 1;
    public perc: number = 0;
    public roundedMultiplier: string = "N";
    public roundedMultiplierDesc: string = "";
    public columns: ComplexityColumn[] = [];
    public removeMinNRows: number | undefined = undefined;

    public showHint = true;

    constructor(private activatedRoute: ActivatedRoute, private router: Router,
        private preaggregationSevice: AggregationSevice, private complexityMngtService: ComplexityMngtService,
        private projectService: ProjectService, private dialog: MatDialog, private maxMultStorageService: MaxMultStorageService) { }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if (projectId) {
                this.projectId = projectId;
                this.projectService.setProjectId(projectId);
                this.loadData();
            }
        });
    }

    private loadData() {
        this.loading = true;
        this.complexityMngtService.getComplexityEstimation(this.projectId!)
            .then(resp => {
                if (!resp.showToUser) {
                    this.proceedToNextPage();
                }
                this.loadModel(resp);
                this.loading = false;
            });
    }

    public async removeColumn(i: number) {
        if (this.loading || this.projectId === undefined) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.complexityMngtService.removeColumn(this.projectId, i);
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    public async unremoveColumn(i: number) {
        if (this.loading || this.projectId === undefined) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.complexityMngtService.unremoveColumn(this.projectId, i);
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    private loadModel(model: ComplexityEstimationResult) {
        this.roundedMultiplier = model.roundedMultiplier;
        this.roundedMultiplierDesc = model.roundedMultiplierDesc;
        this.columns = model.columns;
        this.removeMinNRows = model.removeMinNRows;
        const existingMaxMult = this.maxMultStorageService.getMaxMult(this.projectId!);
        if (existingMaxMult) {
            this.loadColorBar(model.multiplier, existingMaxMult);
        } else {
            this.maxMultStorageService.setMaxMult(this.projectId!, model.multiplier);
            this.loadColorBar(model.multiplier, model.multiplier);
        }
    }

    private loadColorBar(mult: number, maxMult: number): void {
        this.multiplier = mult;
        if (maxMult > 1) {
            this.perc = 100 * mult / maxMult;
        } else {
            this.perc = 100 * mult;
        }
    }

    public goBackReselectDimensions() {
        this.router.navigateByUrl('/select-columns-dimensions?projectId=' + this.projectId);
    }

    public proceedToNextPage() {
        this.router.navigateByUrl(`/import-wizard?projectId=${this.projectId}&step=Dimensions&complexityDone=true`);
    }

    public async removeColumnCompression(dimIndex: number) {
        if (this.loading || this.projectId === undefined) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.complexityMngtService.removeColumnCompression(this.projectId, dimIndex);
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    showTopValsDialog(columnName: string, compactTopN: number) {
        const dialogRef = this.dialog.open(TopValsModalComponent, {
            data: {
                projectId: this.projectId,
                columnName: columnName,
                compactTopN: compactTopN
            },
        });
        const self = this;
        dialogRef.afterClosed().subscribe(result => {
            self.loadData();
        });
    }

}
